module.exports = __webpack_public_path__ + "media/images/mobile/solutions/35-04d5e51101e40490061e84862874aee1.png";